import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from "react";
import Colors from "../../colors";
import MultilineInput from "../MultilineInput";
import PhoneTextInput from '../PhoneTextInput';
import TextInput from "../TextInput";
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ConfirmationModal from "./ConfirmationModal";
import ModalContainer from "./ModalContainer";

function EditContact({ isVisible, setIsVisible, title, contact, onSave, onDelete }) {
  const [name, setName] = useState('');
  const [program, setProgram] = useState('');
  const [position, setPosition] = useState('');
  const [officeNumber, setOfficeNumber] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [comment, setComment] = useState('');
  const [isdelete, setDelete] = useState(false)
  const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    alignContent: 'center',
  });
  useEffect(() => {
    if (contact) {
      setName(contact.name || "")
      setProgram(contact.program || "")
      setPosition(contact.position || "")
      setOfficeNumber(contact.officeNumber || "")
      setMobileNumber(contact.mobileNumber || "")
      setComment(contact.comment || "")
    }

  }, [contact])
  const [errMsg, setErrMsg] = useState();
  const handleClose = () => setErrMsg();
  const handleMissingRequirements = () => {
    if (name.trim().length === 0 || officeNumber.trim().length === 0) {
      setErrMsg('Please enter name and office number.');
      return;
    }
  };
  const errMsgStyles = {
    color: 'red',
    marginTop: '-12px'
  };
  useEffect(() => {
    if (name.trim().length !== 0 && officeNumber.trim().length !== 0) {
      setErrMsg();
    }
  }, [name, officeNumber]);

  const handleSave = () => {
    if (contact) {
      const newContact = {
        id: contact.id,
        name: name.trim(),
        program: program.trim(),
        position: position.trim(),
        officeNumber,
        mobileNumber,
        comment: comment.trim(),
      };
      onSave(newContact);
    } else {
      const newContact = {
        name: name.trim(),
        program: program.trim(),
        position: position.trim(),
        officeNumber,
        mobileNumber,
        comment: comment.trim(),
      };
      onSave(newContact);
    }
    setIsVisible(false);
  };
  const handledelete = () => {
    onDelete(contact)
    setDelete(false)
    setIsVisible(false)

  }
  return (
    <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} title={title} onClose={handleClose}>
      <div style={{ width: '90%', marginBottom: '10px' }}>
        <TextInput
          label={"Name"}
          value={name}
          setText={setName}
        />
        <TextInput
          label={"Program/Department"}
          value={program}
          setText={setProgram}
        />
        <TextInput
          label={"Position"}
          value={position}
          setText={setPosition}
        />
        <PhoneTextInput
          label={'Office Number'}
          phoneNumberText={officeNumber}
          setPhoneNumberText={setOfficeNumber} />
        <PhoneTextInput
          label={'Mobile Number (optional'}
          phoneNumberText={mobileNumber}
          setPhoneNumberText={setMobileNumber} />
        <MultilineInput
          label={"Additional Comments"}
          value={comment}
          setText={setComment}
        />
      </div>
      {errMsg && <span style={errMsgStyles}>{errMsg}</span>}
      <ButtonContainer>
        {name.trim().length === 0 || officeNumber.trim().length === 0
          ? <OutlineButton
            color={Colors.mediumGray}
            label={'Save Changes'}
            onClick={handleMissingRequirements}>
          </OutlineButton>
          :
          <OutlineButton
            color={Colors.green}
            label={'Save Changes'}
            onClick={handleSave} />
        }
        {contact && <OutlineButton
          color={Colors.red}
          label={'Delete'}
          onClick={() => setDelete(true)} />}
      </ButtonContainer>
      {isdelete && <ConfirmationModal
        title={"Do you want to permanently delete this contact?"}
        mainAction={"Yes"}
        isVisible={isdelete}
        setIsVisible={setDelete}
        mainActionHandler={handledelete}
        color={Colors.green} />}
    </ModalContainer>
  );
}

export default EditContact;
